import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { DataSource } from '@/modules/core/datasource/models/DataSource';
import { isEmpty } from 'lodash';

export class DashboardFilterOption extends BaseModel {
  /**
   * @var {string}
   */
  key;

  /**
   * @var {string}
   */
  format;

  /**
   * @var {string}
   */
  field;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  label;

  /**
   * @var {DataSource}
   */
  data_source;

  /**
   * @var {boolean}
   */
  is_predefined;

  /**
   * @var {boolean}
   */
  limit_available_values;

  /**
   * @var {int}
   */
  order;

  /**
   * @var {string}
   */
  source_filter_set_id;

  /**
   * @var {string}
   */
  client_id_column_name;

  /**
   * @var {boolean}
   */
  is_live_integration;

  /**
   * @var {boolean}
   */
  skip_hidden_filter;

  /**
   * @var {array}
   */
  values;

  constructor(model = {}) {
    super();

    this.key = model.key || null;
    // eslint-disable-next-line tap/no-raw-text-js
    this.format = model.format || 'id';
    // eslint-disable-next-line tap/no-raw-text-js
    this.field = model.field || 'id';
    this.type = model.type || null;
    this.label = model.label || null;
    this.data_source = !isEmpty(model.data_source) ? new DataSource(model.data_source) : null;
    this.is_predefined = model.is_predefined || false;
    this.limit_available_values = model.limit_available_values || false;
    this.order = model.order || 0;
    this.source_filter_set_id = model.source_filter_set_id || null;
    this.client_id_column_name = model.client_id_column_name;
    this.is_live_integration = model.is_live_integration;
    this.skip_hidden_filter = model.skip_hidden_filter;
    this.values = model.values;
  }
}
